import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed, inject, ref, watch } from "vue";
import CheckboxInput from "@/components/shared/inputs/CheckboxInput.vue";
import { IDateInfo, ISeatInfo } from "@/domain/entities/book";
import SeatsLayoutSwiper from "@/components/book/SeatsLayoutSwiper.vue";
import InlineSvg from "vue-inline-svg";
import {
  BookIntervalCode,
  PROVIDE_KEY_SHOW_ERROR_MODAL,
  ShowErrorModal,
} from "@/types";
import { useBookStore } from "@/stores/bookStore";
import InfoModal from "../shared/modal/base/InfoModal.vue";


const __default__ = {
  name: "SeatSelection",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  turnId: {
    type: String,
    required: true,
  },
  bookingDates: {
    // 예약 진행중인 날짜
    type: Array as PropType<IDateInfo[]>,
  },
  selectedDateInfo: {
    type: Object as PropType<IDateInfo>,
  },
  duplicateSeatNo: {
    type: String,
  },
  autoSeatAssign: {
    type: Boolean,
    default: false,
  },
  currentBookInterval: {
    type: String as PropType<BookIntervalCode>,
  },
},
  emits: ["onClickSeat", "onChangedAutoSeatAssign", "onFetchedSeatLayout"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;

const bookStore = useBookStore();
const swipedDown = ref(false);
const seatsInfosList = ref<(ISeatInfo | undefined)[][]>([]);
const seatsRowsNumList = ref<number[]>([]);
const seatsColumnsNumList = ref<number[]>([]);

const shouldShowSeats = computed(() => {
  if (swipedDown.value) {
    return false;
  }
  return props.bookingDates!.length > 0;
});

const dateToShow = computed(() => {
  if (props.selectedDateInfo) {
    return formatDay(
      props.selectedDateInfo,
      props.currentBookInterval === BookIntervalCode.MONTH
        ? "YYYY-MM"
        : "YYYY-MM-DD"
    );
  }
  if (props.bookingDates && props.bookingDates.length > 0) {
    return formatDay(props.bookingDates[0], "YYYY-MM-DD");
  }
  return "";
});

const formatDay = (dateInfo: IDateInfo, format: string) => {
  return dateInfo.dayJs.format(format);
};

// const mySeatNo = ref("");
const selectedSeat = ref<HTMLElement>();
const onClickSeat = (seatInfo: ISeatInfo) => {
  const seat = document.getElementById(seatInfo.seatNo);
  if (seat === null || seatInfo.bookedBySomeone) return;

  selectedSeat.value = seat;
  emit("onClickSeat", seatInfo.seatNo, props.selectedDateInfo);
};

const onClickAutoAssginHelp = () => {
  toggleShowAutoAssignInfoModal(true);
};
const onChangedAutoSeatAssign = (checked: boolean) => {
  emit("onChangedAutoSeatAssign", checked);
};

/** 좌석 정보 조회 */
const getSeatLayout = async (dateInfo: IDateInfo) => {
  const seatLayoutResult = await bookStore.getSeatLayout(
    props.turnId,
    dateInfo.date,
    props.currentBookInterval === BookIntervalCode.MONTH,
    dateInfo.bookableDate?.allocUid
  );

  if (!seatLayoutResult.isSuccess) {
    showErrorModal(
      "좌석 배치도 조회 오류",
      seatLayoutResult.errorMessage,
      seatLayoutResult.resultCode,
      seatLayoutResult.errorTime
    );
    return;
  }

  seatsInfosList.value = seatLayoutResult.data?.seatLayout ?? [];
  seatsRowsNumList.value = seatLayoutResult.data?.numberOfRows ?? [];
  seatsColumnsNumList.value = seatLayoutResult.data?.numberOfColumns ?? [];

  emit("onFetchedSeatLayout", dateInfo, seatsInfosList.value);
};

/** 선점좌석 자동배정 팝업 처리 */
const shouldShowAutoAssignInfoModal = ref(false);
const toggleShowAutoAssignInfoModal = (show: boolean) => {
  shouldShowAutoAssignInfoModal.value = show;
};

const toggleShowSeatsLayout = () => {
  swipedDown.value = !swipedDown.value;
};

watch(
  () => props.selectedDateInfo,
  (newVal, oldVal) => {
    if (!newVal || newVal.date === oldVal?.date) return;

    getSeatLayout(newVal);
  },
  { immediate: true }
);

__expose({ toggleShowSeatsLayout });

const __returned__ = { props, emit, showErrorModal, bookStore, swipedDown, seatsInfosList, seatsRowsNumList, seatsColumnsNumList, shouldShowSeats, dateToShow, formatDay, selectedSeat, onClickSeat, onClickAutoAssginHelp, onChangedAutoSeatAssign, getSeatLayout, shouldShowAutoAssignInfoModal, toggleShowAutoAssignInfoModal, toggleShowSeatsLayout, CheckboxInput, SeatsLayoutSwiper, get InlineSvg() { return InlineSvg }, InfoModal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})